import { Box, Grid } from '@material-ui/core'
import React from 'react'
import { cardsStyles } from './styles'
import completedIcon from '../../../assets/images/completedIcon.svg'
import taskOverdue from '../../../assets/images/taskOverdueIcon.svg'

const CountryCards = ({countryInfo}) => {
  const classes = cardsStyles()

  return (
    <Box style={{ padding: '40px' }}>
      <h3 className={classes.title}>País</h3>
      <Box className={classes.sectionContainer}>
         <p className={classes.titleSection}>Socios evaluados</p>
      <Grid
        container
          sx={12}
          spacing={3}
      >
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon}>#</span>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Encuestas enviadas
                </p>
                <p className={classes.amount}>{countryInfo.encuestasEnviadas || '0'}</p>
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon}>#</span>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Encuestas conciliadas
                </p>
                <p className={classes.amount}>{countryInfo.encuestasConsolidadas || '0'}</p>
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon}>#</span>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Encuestas pendientes
                </p>
                <p className={classes.amount}>{countryInfo.encuestasPendientes || '0'}</p>
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon}>#</span>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Encuestas sin enviar
                </p>
                <p className={classes.amount}>{countryInfo.encuestasSinEnviar || '0'}</p>
              </div>
            </Box>
          </Grid>
      </Grid>
      <p className={classes.titleSection}>Acciones de mejora</p>
        <Grid
          container
          sx={12}
          spacing={3}
        >
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon} style={{backgroundColor: '#F5CD261A', color: '#F5CD26', border: '3px solid #F5CD26'}}>#</span>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Total acciones
                </p>
                <p className={classes.amount}>{countryInfo.totalAcciones}</p>
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon} style={{backgroundColor: '#65BA1019', backgroundImage: `url(${completedIcon})`}}/>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Acciones completas
                </p>
                <p className={classes.amount}>{countryInfo.totalCompletadas || '0'}</p>
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon} style={{border:'3px solid #2699FB', color: '#2699FB', backgroundColor: '#2699FB1A' }}>!</span>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Acciones pendientes
                </p>
                <p className={classes.amount}>{countryInfo.totalPendientes}</p>
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box className={classes.cardContainer}>
              <span className={classes.icon} style={{backgroundColor: '#BA33101A', backgroundImage: `url(${taskOverdue})`}}/>
              <div className={classes.textContainer}>
                <p className={classes.titleCard}>
                  Acciones vencidas
                </p>
                <p className={classes.amount}>{countryInfo.totalVencidas}</p>
              </div>
            </Box>
          </Grid>
      </Grid>
     </Box>
    </Box>
  )
}

export default CountryCards